








import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zakazka/store/edit';
import { NAME as ZAKAZKA_ZALOHA } from '@/modules/servis/zalohy/constants';
import { ZAK_ZALOHA } from '@/modules/servis/zakazka/constants';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

export default EditStoreMixin.extend({
	name: 'ZalohaList',
	data() {
		return {
			ZAKAZKA_ZALOHA,
			ZAK_ZALOHA,
		};
	},
	computed: {
		...genVuexComputeds(store),
	},
	methods: {
		editClick({ data }: { data: any }) {
			const filter = {
				ZakazkaId: this.ZakazkaId!,
				ZakazkaNr: this.ZakazkaNr,
				ZakaznikIdText: this.ZakaznikIdText,
				VozidloText: this.VozidloText,
			};
			const id = data.ID;
			openEdit(ZAKAZKA_ZALOHA, PageMode.EDIT, { id, filter });
		},
	},
});
